import { Navigate } from 'react-router-dom';
import { getSecureItem } from '../Utils/secureStorage';

const PrivateRoute = ({ Component, updateHeaderFun }) => {
  const loginUser = getSecureItem('accessToken');
  let isLogin = false;
  if (loginUser !== null) {
    isLogin = true;
  }
  return isLogin ? (
    <Component updateHeaderFun={typeof updateHeaderFun !== 'undefined' ? updateHeaderFun : ''} />
  ) : (
    <Navigate to='/' />
  );
};

export default PrivateRoute;
